import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material'
import { defineCustomElements } from '@ionic/pwa-elements/loader'
import App from './App'

// Initialize PWA elements for Capacitor
defineCustomElements(window)

// 創建自定義主題（可選）
const theme = createTheme({
  palette: {
    primary: {
      main: '#3966f8',
    },
    secondary: {
      main: '#3999f8',
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* 重置CSS */}
      <App />
    </ThemeProvider>
  </React.StrictMode>
)